import React, { useState, useEffect } from "react";
import Navbar from "./Navbar";
import Cookies from "js-cookie";
import axios from "axios";
import url from "../../function/url";
import Swal from "sweetalert2";
import ReactPaginate from "react-paginate";
function NewAdsRequests() {
    const ID = Cookies.get("log_id");
    const [ads,setAds] = useState([]);
    const [telecallers,setTelecallers] = useState([]);
    function AllAdsRequest() {
        axios.get(`${url.path}/all_ads_requests/`)
        .then((res) =>{
            if(res.data.status){
                var ads = res.data.ads;
                var tele = res.data.telecaller;
                setAds([])
                ads.map((c)=>{
                    setAds((prevState) =>[
                        ...prevState, c
                    ])
                })
                setTelecallers([])
                tele.map((t)=>{
                    setTelecallers((prevState) =>[
                        ...prevState, t
                    ])
                })
            }
        }).catch((err) => {
          console.log("ERROR", err);
        });
    }
    useEffect(()=>{
        AllAdsRequest();
    },[])
    const itemsPerPage = 3;
    const [searchTerm, setSearchTerm] = useState("");
    const [currentPage, setCurrentPage] = useState(0);

    const filteredData = ads.filter((item) =>
      item.Product_Name.toLowerCase().includes(searchTerm.toLowerCase())
    );

    const offset = currentPage * itemsPerPage;
    const currentItems = filteredData.slice(offset, offset + itemsPerPage);
    const pageCount = Math.ceil(filteredData.length / itemsPerPage);

    const handlePageClick = ({ selected }) => {
      setCurrentPage(selected);
    };
    function searchTable(){
      var rows = document.querySelectorAll('#productstable tbody tr');
      var val = document.getElementById('search').value.trim().replace(/ +/g, ' ').toLowerCase();
      rows.forEach(function(row) {
        var text = row.textContent.replace(/\s+/g, ' ').toLowerCase();
        row.style.display = text.includes(val) ? '' : 'none';
      });
    }
        const Toast = Swal.mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
            didOpen: (toast) => {
            toast.onmouseenter = Swal.stopTimer;
            toast.onmouseleave = Swal.resumeTimer;
            },
        });
        const [selectedTelecallers, setSelectedTelecallers] = useState({});
        const handleTelecallerChange = (requestId, telecallerId) => {
          setSelectedTelecallers((prev) => ({
            ...prev,
            [requestId]: telecallerId,
          }));
        };

    function AssignTelecaller(e) {
        e.preventDefault();
        const formdata = new FormData();
        Object.entries(selectedTelecallers).forEach(([requestId, telecallerId]) => {
            formdata.append('values', JSON.stringify({ requestId, telecallerId }));
          });
        axios.post(`${url.path}/assign_telecaller_ads/`,formdata)
        .then((res) =>{
            if(res.data.status){
                Toast.fire({
                    icon:'success',
                    title:'Telecaller Assigned..'
                })
                AllAdsRequest();
            }
        }).catch((err) => {
                console.log("ERROR", err);
              });
    }
    return(
        <>
        <Navbar />
        <center>
            <h3 style={{fontSize:'20px',position:'relative',top:'10px'}}>Ads Requests</h3>
            </center>
            <div className="search-container">
            <input
              type="text"
              placeholder="Search..."
              onKeyUp={searchTable}
              className="search-input"
              id="search"
            />
          </div>
        <div className="table-container">
      <table className="responsive-table" id="productstable">
        <thead>
          <tr>
            <th>Sl.No</th>
            <th>Company Name</th>
            <th>Product Name</th>
            <th>Start Date</th>
            <th>End Date</th>
            <th>Telecaller</th>
            <th>Action</th>
            <th>Status</th>
          </tr>
        </thead>
        <tbody>
          {ads.map((i,index) => (
            <tr key={i.id}>
              <td>{index+1}</td>
              <td>{i.Company_Name}</td>
              <td>{i.Product_Name}</td>
              <td>{i.Start_Date}</td>
              <td>{i.End_Date}</td>
              {i.Assigned_Telecaller ? (
                <td>{i.Assigned_Telecaller}</td>
              ) : (
                <td><form>
                    <select  value={selectedTelecallers[i.id] || ''}
                    onChange={(e) => handleTelecallerChange(i.id, e.target.value)}>
                        <option>--Select--</option>
                        {telecallers && telecallers.map((t) =>(
                            <option value={t.id}>{t.Employee_Name}</option>
                        ))}
                    </select>
                    </form></td>
              )}
                {i.Assigned_Tele ? (
                  <td><button type="button" style={{width:'80px',backgroundColor:'gainsboro',color:'black',borderRadius:'5px'}} disabled>Assigned</button></td>
                ) : (
                  <td><button type="button" style={{width:'80px',backgroundColor:'gainsboro',color:'black',borderRadius:'5px'}} onClick={AssignTelecaller}>Assign</button></td>
                )}
                
                <td>{i.Admin_Approved_Status}</td>
                    
            </tr>
          ))}
        </tbody>
      </table>
      {filteredData.length > itemsPerPage && (
        <ReactPaginate
          previousLabel={"← Previous"}
          nextLabel={"Next →"}
          breakLabel={"..."}
          pageCount={pageCount}
          marginPagesDisplayed={2}
          pageRangeDisplayed={3}
          onPageChange={handlePageClick}
          containerClassName={"pagination"}
          activeClassName={"active"}
        />
      )}
    </div>
        </>
    );
}
export default NewAdsRequests;